// | URL processing
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFormURLEncoded from "../Data.FormURLEncoded/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import {imgixUrl} from "./foreign.js";
const stripFUE = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dCodePoints.dropWhile(v => v !== 63);
  return x => {
    const $1 = Data$dFormURLEncoded.decode((() => {
      const $1 = $0(x);
      return Data$dString$dCodeUnits.drop(Data$dString$dCodeUnits.length(Data$dString$dCodePoints.take(1)($1)))($1);
    })());
    if ($1.tag === "Nothing") { return []; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
})();
const setQueryParams = params => uri => {
  const $0 = Data$dFormURLEncoded.encode(Data$dArray.unionBy(x => y => x._1 === y._1 && (() => {
    if (x._2.tag === "Nothing") { return y._2.tag === "Nothing"; }
    if (x._2.tag === "Just") {
      if (y._2.tag === "Just") { return x._2._1 === y._2._1; }
      return false;
    }
    return false;
  })())(Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(v._1, Data$dMaybe.$Maybe("Just", v._2)))(params))(stripFUE(uri)));
  return Data$dString$dCodePoints.take(Data$dString$dCodePoints.countPrefix(v => v !== 63)(uri))(uri) + (() => {
    if ($0.tag === "Nothing") { return "?"; }
    if ($0.tag === "Just") { return "?" + $0._1; }
    $runtime.fail();
  })();
};
const makeImgUrl = urn => imgixUrl + urn;
const adjustImage = params => setQueryParams(Data$dSemigroup.concatArray([Data$dTuple.$Tuple("w", params.w), Data$dTuple.$Tuple("h", params.h)])((() => {
  if (!params.crop) { return []; }
  if (params.crop) { return [Data$dTuple.$Tuple("crop", "focalpoint"), Data$dTuple.$Tuple("fit", "crop")]; }
  $runtime.fail();
})()));
export {adjustImage, makeImgUrl, setQueryParams, stripFUE};
export * from "./foreign.js";
